module.exports = __webpack_public_path__ + "images/emoji/u6708.7c5ecbf8b1e7801782fd.png";